import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTrackOpenedPlansModal } from "@air/analytics";
import { Modal, ModalCloseButton } from "@air/primitive-modal";
import { Spinner } from "@air/primitive-spinner";
import { useBreakpointsContext } from "@air/provider-media-query";
import { useFlags } from "launchdarkly-react-client-sdk";
import Link from "next/link";
import { memo, useEffect } from "react";
import { PlanInfo } from "~/components/Modals/PlansModal/components/PlanInfo";
import { planPricingToPlanInfo } from "~/components/Modals/PlansModal/utils";
import { Routes } from "~/constants/routes";
import { PAID_PLANS_MODAL_TITLE } from "~/constants/testIDs";
import { NEW_TAB } from "~/constants/urls";
import { usePlansList } from "~/hooks/usePlansList";
import { useAccountContext } from "~/providers/AccountProvider";
import { reportErrorToBugsnag } from "~/utils/ErrorUtils";
export const UpgradePlanModal = /*#__PURE__*/ memo((param)=>{
    let { onClose, subscription } = param;
    const { data, error, isLoading: isPlansListLoading } = usePlansList();
    var _data_plans;
    const plans = (_data_plans = data === null || data === void 0 ? void 0 : data.plans) !== null && _data_plans !== void 0 ? _data_plans : [];
    const { trackOpenedPlansModal } = useTrackOpenedPlansModal();
    const { isAboveSmallScreen } = useBreakpointsContext();
    const { fixedPricing: fixedPricingFlag } = useFlags();
    const { data: account } = useAccountContext();
    useEffect(()=>{
        if (error) {
            reportErrorToBugsnag({
                error,
                context: "Failed to fetch plans from PaidPlans modal"
            });
        }
    }, [
        error
    ]);
    const plansInfo = plans.map((plan)=>planPricingToPlanInfo(plan, subscription === null || subscription === void 0 ? void 0 : subscription.plan, fixedPricingFlag));
    useEffect(()=>{
        trackOpenedPlansModal();
    }, [
        trackOpenedPlansModal
    ]);
    return /*#__PURE__*/ _jsx(Modal, {
        dangerouslyBypassFocusLock: true,
        isOpen: true,
        onDismiss: onClose,
        className: "mt-8 w-full max-w-[1200px] p-0",
        children: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex justify-between px-4 pt-6 sm:px-8 sm:pt-8",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("h1", {
                                    "aria-hidden": true,
                                    className: "mb-2.5 text-24 font-semibold",
                                    "data-testid": PAID_PLANS_MODAL_TITLE,
                                    children: !isAboveSmallScreen || !account ? "Choose your plan" : "Choose your plan, ".concat(account === null || account === void 0 ? void 0 : account.firstName)
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex flex-col justify-between",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "flex flex-col items-center justify-between pb-4 sm:flex-row sm:pb-5",
                                        children: /*#__PURE__*/ _jsxs("p", {
                                            className: "px-6 text-center text-14 sm:px-0 sm:text-left",
                                            children: [
                                                "Pay annually to save 17%! To learn more about our plans, check out our",
                                                " ",
                                                /*#__PURE__*/ _jsx(Link, {
                                                    className: "text-blue-10",
                                                    href: Routes.marketing.pricing,
                                                    target: NEW_TAB,
                                                    rel: "noopener noreferrer",
                                                    children: "Pricing Page"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(ModalCloseButton, {
                            onClick: onClose
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "flex flex-col justify-center border-t border-t-grey-5 sm:flex-row",
                    children: isPlansListLoading ? /*#__PURE__*/ _jsx("div", {
                        className: "flex min-h-[556px] flex-1 items-center justify-center",
                        children: /*#__PURE__*/ _jsx(Spinner, {
                            className: "text-teal-9"
                        })
                    }) : plansInfo.map((plan)=>/*#__PURE__*/ _jsx(PlanInfo, {
                            ...plan,
                            subscribed: subscription.subscribed,
                            onClose: onClose
                        }, plan.id))
                })
            ]
        })
    });
});
UpgradePlanModal.displayName = "UpgradePlanModal";
